module.exports = __webpack_public_path__ + "img/diagnostico-apresentacao.d68d0882.png";